// These are used in Health Assistant Screen
// These are the loggers types from our end(GoodFlipCare) and others(ViewMaxRWE)
// Following are used in others(ViewMaxRWE)
// "diet" | "exercise" | "fatigue" | "hand grip" | "protein" | "bca" | "sleep" | "steps" | "water" | "general"
export const LOGGERS_TYPES = {
  "water-logs": "water",
  "steps-logs": "steps",
  "sleep-logs": "sleep",
  "medication-logs": "medication",
  // "protein-logs": "protein",
  // "bca-logs": "bca",
  "fatigue-logs": "fatigue",
  // "hand-grip-logs": "hand grip",
  "exercise-logs": "exercise",
  "diet-logs": "diet",
  "symptom-logs": "symptom",
  // "general-logs": "general",
} as const;

/** Fallback goal values when loggers API doesn't provide goal_value */
export const DEFAULT_GOAL_VALUES: Record<string, number> = {
  water: 2000,
  steps: 10000,
  sleep: 8,
  exercise: 30,
  diet: 2000,
  fatigue: 0,
  medication: 0,
};

/** Fallback units when loggers API doesn't provide unit */
export const DEFAULT_UNITS: Record<string, string> = {
  water: "ml",
  steps: "steps",
  sleep: "hrs",
  exercise: "mins",
  diet: "kcal",
  fatigue: "",
  medication: "",
};
